// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37_pX","inner":"Footer_inner__2do0b","nextIcon":"Footer_nextIcon__2DzkO","innerLeft":"Footer_innerLeft__20zqe"};